import html2canvas from "html2canvas";
import pdfMake from "pdfmake";

import moment from "moment";
import NewReservationModalView from "../common/calendar/newReservationModal.html";

angular.module("locations_reservations")

    .controller("LocationsReservationsTimelineCtrl", ['$timeout', 'ConfigurationsGantt', '$http', 'LoginService', '$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', '$filter', '$translate','$sce',
        function ($timeout, ConfigurationsGantt, $http, LoginService, $scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile,  $filter, $translate, $sce) {
            $scope.gantt_data = [];
            $scope.filter = {};
            $scope.filter.date_from = new Date(new Date().setHours(0, 0, 0, 0));
            $scope.filter.date_to = new Date(new Date().setHours(23, 59, 59, 59));
            $scope.filter.date_to.setDate($scope.filter.date_from.getDate() + 4);
            $scope.configurationGant = null;
            $scope.timeFrames = {};
            var start = null;
            var end = null;

            /*<start = ConfigurationsGantt.filter(function (config) {
                                                return config.code == "TIMELINE_START_TIME_DAY_WORK";
                                            }).map((config) => config.value);
                end = ConfigurationsGantt.filter(function (config) {
                                            return config.code == "TIMELINE_END_TIME_DAY_WORK";
                                        }).map((config) => config.value);*/
            start = ConfigurationsGantt.filter(function (config) {
                                                    return config.code == "TIMELINE_START_TIME_DAY_WORK";
                                                }).map(function (config) { return config.value; });
            end = ConfigurationsGantt.filter(function (config) {
                                            return config.code == "TIMELINE_END_TIME_DAY_WORK";
                                        }).map(function (config) { return config.value; });

            if (ConfigurationsGantt != null && start != null && end != null) {
               
                $scope.timeFrames = {
                    day: {
                        start: moment(start[0], 'HH:mm'),
                        end: moment(end[0], 'HH:mm'),
                        working: true, // This is a working period
                        default: true // It will be used for each day
                    },
                    closed: {
                        magnet: false, // This will disable magnet snapping
                        working: false // We don't work when it's closed
                    }
                };
            } 

            //API gantt
            $scope.registerApi = function (api) {
                $scope.api = api;
                api.directives.on.new($scope, function (dName, dScope, dElement, dAttrs, dController) {
                    if (dName === 'ganttTask') {
                        dElement.bind('click', function (event) {
                            //$scope.addEventTask(dScope.task.model.task_id);
                            $scope.newLocationReservation(dScope.task.model.task_id, dScope.task.model.from, dScope.task.model.to, dScope.task.model.location_id);

                        });
                    }
                    
                })
                api.tasks.on.add($scope, function (task) {
                    task.model.location_id = task.row.model.id;
                })
                api.tasks.on.change($scope, function (task) {
                    $scope.newLocationReservation(null, task.model.from, task.model.to, task.model.location_id);
                });
                                
            };
            $scope.drawTaskFactory = function () {
                var newTask = {
                    id: 51981981989185,
                    name: 'New Task'
                    // Other properties
                }
                return newTask;
            }

            $scope.ganttOptions = {
                headers: ["day", "hour", "minute"],
                viewScale: "30 minutes",
                expandToFit: true,
                allowSideResizing: false,
                minWidth: 800,
                columnWidth: 20,
                timeFrames: $scope.timeFrames,
                timeFramesNonWorkingMode: "cropped",
                headersFormats: {
                    day: 'D',
                    hour: 'H',
                    minute: 'mm'
                }
            }

            let loadData = function () {
             
                $scope.gantt_data = [];
                var options = { date_from: $scope.filter.date_from, date_to: $scope.filter.date_to};
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'Locations/LocationAndReservations',
                    params: options
                }).then(function (results, status, headers, config) {
                    var i = 0;
                    angular.forEach(results.data, function (location) {
                        $scope.gantt_data.push({
                            id: location.id,
                            name: location.name,
                            height: "2em",
                            tasks: []
                        });
                        if (location.FK_locations_reservations_locations != null) {
                            angular.forEach(location.FK_locations_reservations_locations, function (reservation) {
                                addToGantt($scope.gantt_data[i], reservation);
                            });
                        }
                        i++;
                    });
                });                
            }

            let addToGantt = function (location, reservation) {
                if (reservation.date_to == null || typeof reservation.date_to == "undefined") reservation.date_to = moment(reservation.date_from).add(1, 'days');
                var contentTooltip = "";
                contentTooltip += "<b>" + reservation.notes + "</b></br>"
                contentTooltip += "Desde: " + moment(reservation.date_from).format("DD/MM/YYYY HH:mm") + "</br>";
                contentTooltip += "Hasta: " + moment(reservation.date_to).format("DD/MM/YYYY HH:mm") + "</br>";
                
                if (reservation.status == 'pending') contentTooltip += "" + $filter('translate')('locations_reservations.status_pending') + "</br>";
                if (reservation.status == 'cancelled') contentTooltip += "" + $filter('translate')('locations_reservations.status_cancelled') + "</br>";
                if (reservation.status == 'rejected') contentTooltip += "" + $filter('translate')('locations_reservations.status_rejected') + "</br>";
                if (reservation.status == 'confirmed') contentTooltip += "" + $filter('translate')('locations_reservations.status_confirmed') + "</br>";
                contentTooltip = contentTooltip.slice(0, -2);

                var color = "";
                if (reservation.status == 'cancelled' || reservation.status == 'rejected') color = "#ed5565";
                if (reservation.status == 'confirmed') color = "#1ab394";
                if (reservation.status == 'pending' ) color = "#f8ac59";

                location.tasks.push({
                    location_id: location.id, 
                    task_id: reservation.id,
                    name: reservation.notes,
                    color: color,
                    content: "<font color='white'>" + reservation.notes + "</font>",
                    contentTooltip: $sce.trustAsHtml(contentTooltip),
                    from: moment(reservation.date_from),
                    to: moment(reservation.date_to)
                });
            }

            loadData();

            $scope.changeDate = function () {
                loadData();
            }

            $scope.newLocationReservation = function (id, startDate, endDate, location_id) {
                $('.popover').hide();
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: NewReservationModalView,
                    controller: "NewReservationModalCtrl",
                    size: 'lg',
                    resolve: {
                        id: function () {
                            return id;
                        },
                        startDate: function () {
                            return startDate;
                        }, endDate: function () {
                            return endDate;
                        },
                        location_id: function () {
                            return location_id;
                        }
                    }
                });

                $modalInstance.result.then(function () {
                    $scope.api.data.clear();
                    $scope.api.columns.clear();
                    $scope.api.columns.refresh();
                    $scope.api.rows.refresh();

                    loadData();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            }

            $scope.pdfMaker = function () {
                var container = angular.element('#gantt-container');

                container.show();

                var results = document.getElementById('gantt-to-export');

                var width = angular.element('#gantt-to-export .gantt-side').width() + angular.element('#gantt-to-export .gantt-scrollable-header').width();
                var width2 = angular.element('#gantt-to-export').width()

                html2canvas(document.querySelector("#gantt-to-export"), {
                    width: width2,
                    height: 4000, }).then(
                    canvas => {
                    var data = canvas.toDataURL("image/png", 1.0);
                    $(".modal").css("height", "");
                    var docDefinition = {
                        pageSize: {
                            width: canvas.width,
                            height: canvas.height + 200
                        },
                        content: [{
                            image: data,
                            width: canvas.width
                        }]
                    };

                    //@ts-ignore
                    pdfMake.createPdf(docDefinition).download("gantt.pdf");
                    container.hide();

                });
            }

}])

;

